export const environment = {
  production: true,
  host: "https://forhandlerportal.micar.dk",
  port: "443",
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts